export const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
